<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 14:30:33
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-19 14:51:12
-->
<template>
  <div class="content">
    <el-table :data="orders" style="width: 100%">
      <el-table-column label="序号" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderNum"
        label="订单编号"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderTypeName"
        label="订单类型"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="cropName"
        label="种植作物"
        min-width="7%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        label="时间要求"
        min-width="16%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workTypeNames"
        label="作业类型"
        min-width="10%"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="orderArea"
        label="流转面积（亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workArea"
        label="作业面积（亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="statusName"
        label="状态"
        min-width="6%"
        align="center"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :page-size="this.pagination.pageSize"
      :total="pagination.recordTotal"
      :hide-on-single-page="true"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "OrderCompletion",
  data() {
    return {
      orders: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
    };
  },
  props: {
    contractId: {
      type: String,
    },
  },
  filters: {
    formatWorkProgress(value) {
      return `${value}%`;
    },
  },
  created() {
    this.getContractOrderList();
  },
  methods: {
    /**
     * @descripttion: 获取合同订单
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getContractOrderList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, contractId: this.contractId };
      this.$http.contract.getContractOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.orders = orders;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getContractOrderList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  border: 1px solid #dfe7eb;
  border-bottom: none;
  .el-button {
    padding: 5px 12px;
  }
}
</style>
